import { useState, useEffect } from 'react'

export const DEFAULT_HEADER_HEIGHT = 60

export const useHeaderHeight = (): number => {
  const [height, setHeight] = useState<number>(() => {
    if (typeof document === 'undefined') return DEFAULT_HEADER_HEIGHT
    const header = document.querySelector('header[role="banner"]')
    return header ? (header as HTMLElement).offsetHeight : DEFAULT_HEADER_HEIGHT
  })

  useEffect(() => {
    const header = document.querySelector('header[role="banner"]')
    if (!header) return undefined

    setHeight((header as HTMLElement).offsetHeight)

    if (typeof ResizeObserver === 'undefined') return undefined

    const observer = new ResizeObserver(() => {
      setHeight((header as HTMLElement).offsetHeight)
    })
    observer.observe(header)

    return () => {
      observer.disconnect()
    }
  }, [])

  return height
}
